import {getRandomElements} from "../../helpers/array";

export default class BaseCamApi {
    constructor(name, config) {
        if (this.constructor === BaseCamApi) {
            throw new Error('Abstract class BaseCamApi cannot be instantiated');
        }

        this.name = name;
        this.status = config.status;
        this.defaultGender = config.defaultGender;
        this.autoLoginData = config.autoLoginData;
        this.sPopup = Math.random() < (config?.flows?.popup?.rate || 1.0);

        this.banners = new Map();
    }

    /**
     * @returns {boolean}
     */
    get isActive() {
        return this.status !== 'not_available';
    }

    /**
     * @returns {boolean}
     */
    get needsConfirmation() {
        return this.status === 'needs_confirmation';
    }

    /**
     * @param {string} gender
     * @returns {Promise<object[]>}
     */
    async loadRawBanners(gender) {
        throw new Error('Method loadRawBanners is not implemented');
    }

    /**
     * @param {object} rawBanner
     * @returns {CamBanner}
     */
    makeCamBanner(rawBanner) {
        throw new Error('Method makeCamBanner is not implemented');
    }

    /**
     * @param {string} gender
     * @returns {Promise<CamBanner[]>}
     */
    async loadCamBanners(gender) {
        const rawBanners = await this.loadRawBanners(gender);
        return rawBanners.map(rawBanner => this.makeCamBanner(rawBanner));
    }

    /**
     * @param {int} count
     * @param {string|null} gender
     * @returns {Promise<CamBanner[]>}
     */
    async getBanners(count, gender = null) {
        gender = gender || this.defaultGender;

        if (!this.banners.has(gender)) {
            // Store the promises in the map; this way we only load the data once per page
            this.banners.set(gender, this.loadCamBanners(gender));
        }

        return getRandomElements(await this.banners.get(gender), count);
    }

    makeAcceptUrl(params = {}, redirect = null) {
        // Clear undefined values
        Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);

        const searchParams = new URLSearchParams(params);
        if (redirect) {
            searchParams.set('redirect', redirect);
        }
        const query = searchParams.toString();
        return '/cams/accept.' + window.variables.language + '.json' + (query ? `?${query}` : '');
    }
};
